import React from 'react';

export default (_props) => {
  const { className, size, large, small, ...props } = _props;

  // small icon
  if ((size && size.toLowerCase() === 'small') || small) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" className={`audiicon audiicon-small ${className ? className : ''}`} {...props}>
        <g stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd">
          <path d="M20.5,6.5 L20.5,6.5 C21.6045695,6.5 22.5,7.3954305 22.5,8.5 L22.5,20.5 L3.5,20.5 L20.5,17.5 L20.5,4"/>
          <path d="M1.5,6 L17.2497765,1.92954779 C17.7844921,1.7913532 18.3299935,2.11279692 18.4681881,2.64751245 C18.489311,2.72924322 18.5,2.8133197 18.5,2.89773591 L18.5,11.5 L14.5,15.5 L2.75997347,18.6607764 C2.22667862,18.8043558 1.67796363,18.4884289 1.53438424,17.9551341 C1.51156079,17.8703613 1.5,17.7829521 1.5,17.6951606 L1.5,6 Z"/>
          <path d="M14.5 15.5L14.5 11.5 18.5 11.5"/>
        </g>
      </svg>
    );
  }

  // large icon
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" className={`audiicon audiicon-large ${className ? className : ''}`} {...props}>
      <g stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M40.5,13.5 L41.5,13.5 C43.1568542,13.5 44.5,14.8431458 44.5,16.5 L44.5,39.5 C19.1666667,39.5 6.16666667,39.5 5.5,39.5 C4.5,39.5 3.5,38.27843 3.5,37 C3.62814941,38.4647646 4.73797646,39.3831445 5.98893649,39.2650635 L40.5,36.007484 L40.5,13.5 C40.5,11.290861 38.709139,9.5 36.5,9.5"/>
        <path d="M3.5,13.5 L32.7106478,5.5334597 C34.3091208,5.0975125 35.9583443,6.03992591 36.3942915,7.63839894 C36.4644507,7.89564933 36.5,8.16110519 36.5,8.42775116 L36.5,25.5 L28.5,33.5 L5.9667459,38.907981 C4.89267655,39.1657576 3.81300204,38.5040216 3.5552254,37.4299523 C3.51853643,37.2770816 3.5,37.1204181 3.5,36.9632064 L3.5,13.5 Z"/>
        <path d="M28.5 33.5L28.5 25.5 36.5 25.5"/>
      </g>
    </svg>
  );
};
